export default __webpack_public_path__ + "static/media/quad-bike.7ca55211.png";